import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { LinkToTestResultsDoc } from '../links'
import { Path } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'
import { useConfigTypeTitle } from '@eggplant/routing'

const TestResultsIntro = () => {
  const configTypeTitle = useConfigTypeTitle(true)
  const description = `${configTypeTitle} Results shows an overview of results from your test runs. You also can view full details of tests and download logs from this area.`

  return (
    <div className='grid h-full justify-center'>
      <div className='grid w-[36em]'>
        <EmptyStatesPreview
          description={description}
          icon={<Path />}
          renderLink={<LinkToTestResultsDoc />}
          title={`${configTypeTitle} Results`}
        />
      </div>
    </div>
  )
}

export default TestResultsIntro
